const linkUpdater = () => ({
    init() {
        this.storeTrackingParams();
        this.updateLinks();

        const observer = new MutationObserver(() => {
            const cmpCookie = this.getCookie('s_cmp');
            const ufpCookie = this.getCookie('ufp');

            if (cmpCookie || ufpCookie) {
                this.updateLinks();
            }

            if (cmpCookie && ufpCookie) {
                observer.disconnect();
            }
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            characterData: true
        });
    },
    storeTrackingParams() {
        const currentUrl = new URL(window.location.href);
        const cid = currentUrl.searchParams.get('cid');
        const ufp = currentUrl.searchParams.get('ufp');

        if (cid) {
            window.cookie.set('s_cmp', cid, { path: '/', sameSite: 'Lax' });
        }

        if (ufp) {
            window.cookie.set('ufp', ufp, { path: '/', sameSite: 'Lax' });
        }
    },
    getCookie(name) {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) {
                return value;
            }
        }

        return null;
    },
    updateLinks() {
        this.$nextTick(() => {
            const links = document.querySelectorAll('a[href*="cid="], a[href*="ufp="]');
            const cookieValueCMP = this.getCookie('s_cmp');
            const cookieValueUFP = this.getCookie('ufp');

            links.forEach(link => {
                const url = new URL(link.href);

                if (cookieValueCMP) {
                    url.searchParams.set('cid', cookieValueCMP);
                }

                if (cookieValueUFP) {
                    url.searchParams.set('ufp', cookieValueUFP);
                }

                link.href = url.toString();
            });
        });
    }
});

export default linkUpdater;
